export const environment = {
  appName: 'Handyhand',
  currency: 'DKK',
  control: {
    minOfferBid: 205,
    maxOfferBid: 70000,
    isPriceSuggesterFlowTestMode: false,
    currency: 'kr.',
  },
  production: true,
  stripeLive: true,
  env: 'production',
  apiUrl: 'https://api.handyhand.dk/api',
  vectorServiceUrl: 'https://vector.handyhand.dk/api',
  socketUrl: 'https://api.handyhand.dk',
  captchaSiteKey: '6LeiNgMqAAAAALe9O1ShxwfP7QioUHo9FvJxpK6O',
  cvrApiUrl: 'https://cvrapi.dk/api',
  stripeKeyTest: 'pk_test_1Pmuz21OlJyWrTFLVDswcZxZ',
  stripeKeyLive: 'pk_live_wOk7ATsEGoFRsIJh0o8XaoDq',
  dashboardBaseRef: 'https://api.dashboard.handyhand.dk/',
  resizeUrl: 'https://d3r2zfg0xujt92.cloudfront.net',
  cloudFrontImgUrl: 'https://d10a6kin4dgxel.cloudfront.net',
  domain: 'https://handyhand.dk/platform',
  seoBaseHref: 'https://handyhand.dk',
  basePath: '',
  censoringBaseHref: 'https://censoring.handyhand.dk',
  dawaUrl: 'https://dawa.aws.dk/adresser',
  dawaFallbackUrl: 'https://dawa-replication-client-ayx5faanla-ew.a.run.app',
  growthbookContext: {
    apiHost: 'https://cdn.growthbook.io',
    clientKey: 'sdk-lYzefGis1nTLrbK6',
  },
  seo: {
    article: 'a',
    job: 'jobs',
    tips: 'tips',
    priceGuide: 'pris',
    inspiration: 'i',
    guide: 'guide',
    hubIndex: 'hub', // MainCategory (Hub)
    service: 'hh',
    city: 'b',
    region: 'r',
    index: 'index',
  },
};
